import React, { useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Box,
    Typography,
    Avatar
} from '@mui/material';

function BlindPoolBidModal({ open, onClose, player, onConfirm, participantBudget, maxAllowedBid }) {
    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setAmount('');
            setError('');
        }
    }, [open]);

    const handleConfirm = () => {
        const bidAmount = parseFloat(amount);
        if (isNaN(bidAmount) || bidAmount <= 0) {
            setError('Voer een geldig bedrag in.');
            return;
        }
        if (bidAmount > maxAllowedBid) {
            setError(`Bod kan niet hoger zijn dan €${maxAllowedBid}. Houd rekening met het reserveren van €1 voor elke lege plek.`);
            return;
        }
        onConfirm(player, bidAmount);
        onClose();
    };

    if (!player) return null;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Blinde Pool Bieding</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar src={player.photoUrl} alt={player.name} sx={{ mr: 2 }} />
                    <Box>
                        <Typography variant="h6">{player.name}</Typography>
                        <Typography variant="body2" color="text.secondary">{player.clubName} - {player.position}</Typography>
                    </Box>
                </Box>
                <DialogContentText sx={{ mb: 2 }}>
                    Voer hieronder het bedrag in dat je wilt bieden op deze speler.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="amount"
                    label="Bodbedrag"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    error={!!error}
                    helperText={error || `Je kunt maximaal €${maxAllowedBid} bieden.`}
                    InputProps={{
                        startAdornment: <Typography sx={{ mr: 0.5 }}>€</Typography>,
                    }}
                />
                 <Typography variant="caption" color="text.secondary">
                    Huidig budget: €{participantBudget}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button onClick={handleConfirm} variant="contained">Bod Plaatsen</Button>
            </DialogActions>
        </Dialog>
    );
}

export default BlindPoolBidModal;
